/**
 * @ngdoc controller
 * @name RootController
 * @description
 * This component renders the Title Bar.
 *
 * @memberof rootModule
 */
class TitleBarController {
  /**
   * Class constructor
   * @param {Service} $window To access the history API.
   * @ignore
   */
  constructor($window) {
    'ngInject';

    /**
     * The local reference to the `$window` service.
     * @type {Object}
     */
    this.$window = $window;
  }
  /**
   * Callback function to be called when the back button is clicked.
   */
  onBackButtonClick() {
    this.$window.history.back();
  }
}

export default TitleBarController;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/components/titleBar/titleBar.controller.js